import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	monday: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.monday',
		defaultMessage: 'Monday',
		description: 'checkbox label displayed for Monday',
	},
	tuesday: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.tuesday',
		defaultMessage: 'Tuesday',
		description: 'checkbox label displayed for Tuesday',
	},
	wednesday: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.wednesday',
		defaultMessage: 'Wednesday',
		description: 'checkbox label displayed for Wednesday',
	},
	thursday: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.thursday',
		defaultMessage: 'Thursday',
		description: 'checkbox label displayed for Thursday',
	},
	friday: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.friday',
		defaultMessage: 'Friday',
		description: 'checkbox label displayed for Friday',
	},
	saturday: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.saturday',
		defaultMessage: 'Saturday',
		description: 'checkbox label displayed for Saturday',
	},
	sunday: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.sunday',
		defaultMessage: 'Sunday',
		description: 'checkbox label displayed for Sunday',
	},
});
